import { type MutationError, trpc } from '@/shared/api';

interface UseReorderExhibitionPurposesOptions {
  readonly onSuccess?: () => void;
}

/** 목적 탭 순서를 통째로 제출한다 — 서버가 목적 전체 집합과 같은지 확인하고 10 단위로 다시 매긴다. */
export const useReorderExhibitionPurposes = ({
  onSuccess,
}: UseReorderExhibitionPurposesOptions = {}) => {
  const mutation = trpc.productManagement.exhibitionPurposes.reorder.useMutation({ onSuccess });
  const error: MutationError | null = mutation.error;

  return {
    reorderPurposes: (orderedIds: readonly string[]) =>
      mutation.mutate({ orderedIds: [...orderedIds] }),
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 목적 배너의 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
